import { QueovalBase } from "./queoval.base";
import { ProspectBase } from "./classes.registration";


export class ConnectionModel extends QueovalBase {
  lastName: string;
  firstName1: string;
  firstName2: string;
  fullName: string;
  exist: boolean;
  ProspectRegistration: ProspectRegistration;
}

export class ProspectRegistration extends ProspectBase {
  Ident: string;
  Password: string;
  constructor() {
    super();
    this.Ident = '';
    this.Password = '';
  }
}
